<template>
  <div class="personal-my-center">
    <lay-out>
      <Row class="mem-tabs" type="flex">
        <div
          v-for="(item, index) in tablist"
          :key="index"
          class="tab-item cursor"
          :class="activeTab === item.value ? ['active'] : ''"
          @click="handleTabChange(item)"
        >
          <span>{{ item.key }}</span>
        </div>
      </Row>
      <div class="my-order-container">
        <div class="order-search" v-show="activeTab === 1">
          <Input
            v-model="filter.keyword"
            size="large"
            @on-enter="handleOrderSearch"
            placeholder="请输入搜索内容、关键字"
          >
            <i
              @click="handleOrderSearch"
              class="iconfont icon-sousuo1"
              slot="suffix"
            ></i>
          </Input>
          <!-- <div class="searchIcon cursor iconfont icon-sousuo1" @click="handleOrderSearch"></div> -->
        </div>
        <div class="tabs" v-if="statusLists && statusLists.length > 0">
          <Tabs
            v-show="activeTab === 1"
            v-model="tabVal"
            class="search-bar-samll search-bar-samll-left"
            :animated="false"
            @on-click="changeTab"
          >
            <TabPane
              v-for="(item, index) in statusLists"
              :key="index"
              :label="index > 0 ? `${item.key}（${item.qtr}）` : `${item.key}`"
              :name="item.value.toString()"
            ></TabPane>
          </Tabs>
        </div>
        <div class="im-tabs" v-show="activeTab === 2">
          <span
            :class="{ active: Imtab == item.value }"
            v-for="item in imStatus"
            :key="item.value"
            @click="updateImList(item)"
            >{{ item.key
            }}{{ item.key == '全部' ? '' : `（${item.qtr}）` }}</span
          >
        </div>
        <div class="my-order">
          <div
            v-if="activeTab == 1 && itemData && itemData.length > 0"
            v-for="(item, index) in itemData"
            class="items"
            :key="item.id"
          >
            <item-list
              :itemInfo="item"
              size="small"
              @updateList="getOrderList"
            ></item-list>
          </div>
          <div
            v-if="activeTab == 2 && itemData && itemData.length > 0"
            class="items"
            v-for="(item, index) in itemData"
            :key="item.id"
          >
            <im-orderItem :value="item"></im-orderItem>
          </div>
          <div
            class="align-center"
            style="padding-top:80px;"
            v-show="!busy && (!itemData || itemData.length == 0)"
          >
            <img src="@/assets/user/user-empty-2.png" alt width="150px" />
            <p class="f-24 m-t-20" style="color: #a0a0a0;">
              {{
                activeTab == 1
                  ? '您还没有订单哦'
                  : '您还没有积分订单，快去积分商城兑换吧。'
              }}
            </p>
          </div>
          <div class="align-center" v-show="busy">
            <img style="width:100px;" src="@/assets/new-global.gif" alt />
          </div>
        </div>
        <div class="pages" v-if="total > 0 && !busy">
          <z-page
            :total="total"
            :elevator="true"
            :pageSize="filter.pageSize"
            v-model="filter.pageNum"
            @changePageNum="handleChangePage"
          ></z-page>
        </div>
      </div>
    </lay-out>
  </div>
</template>

<script>
import axios from 'axios'

import LayOut from './layout'
import imOrderItem from './imOrderItem'
import itemList from '../../../components/order-item.vue'

export default {
  data() {
    return {
      tabVal: '0',
      tablist: [
        { key: '我的家居订单', value: 1 },
        { key: '我的兑换订单', value: 2 },
      ],
      filter: {
        pageNum: 1,
        pageSize: 10,
        platform: 'zhulogic',
        keyword: '',
        status: 0,
        hasSign: '',
      },
      itemData: [],
      total: 0,
      activeTab: 1,
      busy: true,
      imStatus: [],
      Imtab: -1,
      statusLists: [],
    }
  },
  components: {
    LayOut,
    imOrderItem,
    itemList,
  },
  methods: {
    handleTabChange(item) {
      if (this.busy || this.activeTab == item.value) {
        return false
      }
      this.busy = true
      this.activeTab = item.value
      this.itemData = []
      this.filter.pageNum = 1
      this.total = 0
      history.replaceState({}, '', `?type=${item.value}`)
      if (item.value == '1') {
        this.getOrderList()
      } else {
        this.Imtab = -1
        this.getImOrder()
      }
    },
    handleOrderSearch() {
      this.filter.pageNum = 1
      this.getListsStatus()
      this.getOrderList()
    },
    getOrderList() {
      axios
        .get('/designer_api/stageOrders/stage/v3', {
          globalLoading: true,
          params: this.filter,
        })
        .then(
          (res) => {
            this.itemData = res.list
            this.total = res.total
            this.busy = false
            this.backTop()
          },
          (err) => {
            this.busy = false
          }
        )
    },
    updateImList(item) {
      this.Imtab = item.value
      this.getImOrder()
    },
    getImState() {
      axios
        .get('/designer_api/user/im_order_status_num', {
          globalLoading: true,
        })
        .then(
          (res) => {
            this.imStatus = res
            this.busy = false
          },
          (err) => {
            this.busy = false
          }
        )
    },
    getImOrder() {
      let params = {
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
      }
      if (this.Imtab > 0) {
        params.statusList = []
        params.statusList[0] = this.Imtab
      }
      axios
        .post('/designer_api/user/im_orders_list', params, {
          globalLoading: true,
        })
        .then(
          (res) => {
            this.itemData = res.list
            this.total = res.total
            this.getImState()
          },
          (err) => {
            this.busy = false
          }
        )
    },
    handleChangePage(val) {
      this.filter.pageNum = val
      this.getOrderList()
    },

    /* 获得订单状态栏 */
    getListsStatus() {
      axios
        .get('/designer_api/stageOrders/status_num', {
          params: this.filter,
        })
        .then((res) => {
          this.statusLists = res
        })
    },

    /* 切换tab */
    changeTab(val) {
      if (!val) return false
      this.changeFilter(val)
      this.getListsStatus()
      this.getOrderList()
    },

    // 改变 filter
    changeFilter(val) {
      if (val === '500') {
        this.filter.status = ''
        this.filter.hasSign = 1
      } else if (val == 0) {
        this.filter.status = Number(val)
        this.filter.hasSign = ''
      } else {
        this.filter.hasSign = ''
        this.filter.status = Number(val)
      }
    },

    /* 监听 query status的变化 */
    watchStatus() {
      if (this.$route.query.status) {
        this.changeFilter(this.$route.query.status)
        this.tabVal = this.$route.query.status
      } else if (this.$route.query.status == 0) {
        this.changeFilter(this.$route.query.status)
        this.tabVal = '0'
      } else {
        this.tabVal = '0'
      }
    },
  },
  watch: {
    $route: function() {
      this.busy = true
      this.filter.keyword = ''
      this.activeTab = this.$route.query.type
        ? Number(this.$route.query.type)
        : 1
      this.watchStatus()
      this.getListsStatus()
      this.getOrderList()
    },
  },
  created() {
    this.activeTab = this.$route.query.type ? Number(this.$route.query.type) : 1
    if (this.activeTab == 1) {
      this.watchStatus()
      this.getListsStatus()
      this.getOrderList()
    } else {
      this.getImOrder()
    }
  },
}
</script>

<style lang="scss" scoped>
.my-order-container {
  padding: 30px;
  background: #fff;
  .order-search {
    width: 427px;
    margin-bottom: 20px;
    display: flex;
    .ivu-input-wrapper {
      width: 390px;
    }
    .icon-sousuo1 {
      cursor: pointer;
    }
    .searchIcon {
      height: 36px;
      width: 36px;
      background: #313131;
      color: #fff;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
    }
  }
  .my-order {
    background: #fff;
    min-height: 410px;
    margin-top: 20px;
    padding: 0;
  }
  .im-tabs {
    span {
      color: #707070;
      font-weight: 500;
      font-size: 14px;
      cursor: pointer;
      &.active {
        color: #313131;
        // -webkit-text-stroke:1px rgba(151,151,151,1);
        font-weight: 600;
      }
      & ~ span {
        margin-left: 30px;
      }
      &:hover {
        color: #313131;
      }
    }
  }
}
</style>
